<template>
<div class="video-info-container">
  <img class="back-btn" v-show='this.type==="1"'  @click="goBack" src="../../assets/images/activity/fragment/fragment-info/back.png">
  <div class="video-info">
    <div class="activity-info">
      <div>投票时间:2021年7月9日--7月16日</div>
      <div>投票规则:每个微信号每天有5次投票机会</div>
    </div>
    <div class="video-box">
      <video class="video" :src="getVideo()" muted controls autoplay controlsList="nodownload"></video>
    </div>
    <div class="video-detail">
      <div class="ranking">
        {{this.ranking}}
      </div>
      <div>{{this.videoInfo.workshopName}}</div>
    </div>
    <div class="operation">
      <div class="support" @click="handleSupport">
        <img src="../../assets/images/activity/uploadVideo/video-like.png">
        {{videoInfo.supportCount ? videoInfo.supportCount : 0 }}
      </div>
      <div class="share" @click="handleShare">
        <img src="../../assets/images/activity/uploadVideo/video-share.png">
        转发
      </div>
    </div>
  </div>

    <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
      <div class="overlay-wrapper">
        <div>
          点击页面右上角分享视频<img class="arrow" src="../../assets/images/extra-style/arrow.png">
        </div>
      </div>
    </van-overlay>

</div>
</template>
<script>
import activityApi from '@/api/activity'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      enrollId: '0',
      videoInfo: {},
      showOverlay: false,
      wxUserInfo: {},
      ranking: '',
      type: ''
    }
  },
  created () {
    this.enrollId = this.$route.query.enrollId
    this.ranking = this.$route.query.ranking
    this.type = this.$route.query.type
    this.getVideoInfo()
    this.wxUserInfo = sessionStorageUtils.get('wxUserInfo') || {}
  },
  mounted () {
    this.initWxJsSdk()
  },
  methods: {
    async getVideoInfo () {
      let { data } = await activityApi.getVideoEnrollInfo({ enrollId: this.enrollId })
      this.videoInfo = data.resultData.info
    },
    // 初始化微信jssdk
    initWxJsSdk () {
    // console.log(window.__wxjs_is_wkwebview)
    // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }

      const url = `${document.location.origin}/v2/activity/video-enroll/info?enrollId=${this.enrollId}&ranking=${this.ranking}`
      const appMessageShare = {
        title: '博世博修“致敬汽修人”视短频大赛', // 分享标题
        desc: '快来为你喜欢的气汽修人投票吧！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/workshop-video-share.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '博世博修“致敬汽修人”视短频大赛', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/images/share/workshop-video-share.png', // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        this.$emit('error', { errorMsg: error })
      })
    },
    getVideo () {
      return commonUtils.getImageUrl(this.videoInfo.videoFileUri)
    },
    async handleSupport () {
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || {}
      let data = {
        enrollId: this.videoInfo.enrollId,
        wxOpenId: wxUserInfo.openId || '',
        wxNickName: wxUserInfo.wxNickName || ''
      }
      let res = await activityApi.videoSupport(data)
      console.log(res)
      if (res.data.resultCode === '0') {
        this.$toast.success({
          message: '点赞成功',
          duration: 1000
        })
        this.getVideoInfo()
      }
    },
    handleShare () {
      this.showOverlay = true
    },
    goBack () {
      this.$router.push({ path: '/activity/video-enroll/list' })
    }
  }
}
</script>

<style lang='less' scoped>
.video-info-container{
  height: 100vh;
  width: 100vw;
  min-height: 700px;
  background-image: url('../../assets/images/activity/uploadVideo/video-info-bg2.png');
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
.back-btn{
  position: absolute;
  top: 22px;
  left: -8px;
  width: 90px;
}
.video-info{
  width: 80vw;
  height: 300px;
  position: relative;
  left: 10vw;
  top: 300px;
  color: white;
  //background-color: rgba(240, 248, 255, 0.226);
  text-align: center;
  .activity-info{
    font-size: 12px;
    line-height: 22px;
    transform: scale(0.93);
  }
}
.video-box{
  position: relative;
  left: 10vw;
  top: 5px;
  width: 63vw;
  height: 63vw;
  background-image:url('../../assets/images/activity/uploadVideo/videoitem-bg.png');
  background-size:62.5vw 62.5vw ;
  background-repeat: no-repeat;
  .video{
    position: relative;
    top: 1.1vw;
    width: 60vw;
    height: 60vw;
    border-radius: 8px;
  }
}
.video-detail{
  position: relative;
  top:10px;
  height: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  line-height: 24px;
  .ranking{
    text-align: center;
    height: 24px;
    width: 24px;
    margin-right: 10px;
    background-image: url('../../assets/images/activity/uploadVideo/video-num.png');
    background-repeat: no-repeat;
    background-size: 24px 24px ;
  }
}
.operation{
  position: relative;
  top: 30px;
  left: 50vw;
  display: flex;
  img{
    width: 14px;
  }
  .share{
    padding: 10px;
  }
  .support{
    padding: 10px;
  }
}
  .overlay-wrapper {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    line-height: 120px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    .arrow {
      padding-left: 10px;
      width: 80px;
    }
  }
</style>
